import apiClient from "../components/apiClient";
import SetupOptions from "../models/SetupOptions";
import SetupOptionsColor from '../models/SetupOptionsColor';
import SetupOptionsSize from '../models/SetupOptionsSize';

export class SetupOptionsService {
    private static formatDate(dateTimeString: string): string {
        const date = new Date(dateTimeString);
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    }

    static getSetupOptions() : Promise<SetupOptions[]> {
        return apiClient.get<SetupOptions[]>(`/SetupOption/setup-options`)
            .then(res => res.data)
            .then(setupOptions => {
                return setupOptions.map(so => ({
                    ...so,
                    setupUpdts: so.setupUpdts ? this.formatDate(so.setupUpdts) : ''
                }));
            });
    }
    
    static getSetupOption(id: number) : Promise<SetupOptions> {
        return apiClient.get<SetupOptions>(`/SetupOption/GetSetupOption/${id}`).then(res => res.data);
    }

    static getStripeStyles() : Promise<SetupOptions[]> {
        return apiClient.get<SetupOptions[]>(`/SetupOption/GetStripeStyles`).then(res => res.data);
    }

    static getSetupOptionsColors() : Promise<SetupOptionsColor[]> {
        return apiClient.get<SetupOptionsColor[]>(`/SetupOption/GetSetupOptionsColors`).then(res => res.data);
    }
    static getSetupOptionsBaseColors() : Promise<SetupOptions[]> {
        return apiClient.get<SetupOptions[]>(`/SetupOption/setup-options`, {params: {setupType: 'CLR'}}).then(res => res.data);
    }

    static getSetupOptionsSizes() : Promise<SetupOptionsSize[]> {
        return apiClient.get<SetupOptionsSize[]>(`/SetupOption/GetSetupOptionsSizes`).then(res => res.data);
    }

    static getBillOfMaterialsSetupOptions() : Promise<SetupOptions[]> {
        return apiClient.get<SetupOptions[]>(`/SetupOption/GetBillOfMaterialsSetupOptions`).then(res => res.data);
    }

    static getSetupOptByType(type: string) : Promise<SetupOptions[]> {
        return apiClient.get<SetupOptions[]>(`/SetupOption/GetSetupOptByType/${type}`).then(res => res.data);
    }

    static addSetupOption(p: SetupOptions): Promise<SetupOptions> {
        return apiClient.post<SetupOptions>(`/SetupOption/setup-options`, p).then(res => res.data);
    }

    static updateSetupOption(p: SetupOptions): Promise<SetupOptions> {
        return apiClient.put<SetupOptions>(`/SetupOption/setup-options`, p).then(res => res.data);
    }

    static deleteSetupOption(p: number): Promise<boolean> {
        return apiClient.delete<boolean>(`/SetupOption/setup-options/${p}`).then(res => res.data);
    }

}